module.exports = __webpack_public_path__ + "img/games-14.5062f7e0.webp";